import React from "react";
import { useState,useEffect } from "react";
import SalespersonSidebar from "./SalespersonSidebar";
import Editor from 'react-simple-wysiwyg';
import { Helmet } from "react-helmet";
import './classes/EditBlog.css';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { useParams } from 'react-router-dom';
import { Link, useNavigate,useLocation  } from 'react-router-dom';
import { configData } from "../config";
import Loading from './Loading';
import ViewTestimonialPage from "./ViewTestimonialPage";


const EditTestimonialPage =()=>{
      
 
        const initialFormData = {
            title:'',
            user_id: '',
            field_author_title: '',
            summary: '',
            body: '',        
            field_meta_title:'',
            field_meta_keywords:'',
            field_meta_description:'',
            placements: [{ placement_page: '', placement_sort_order: '1' }],
            deleted_placements: [],
            url_alias: ''
        };
        const [formData,setFormData] =useState(initialFormData);
        const [isLoading, setIsLoading] = useState(true);
        const [toggle, setToggle] = useState(2);
        const [errors, setErrors] = useState({});
        const [showSummary, setShowSummary] = useState(false);
            const [editorMode, setEditorMode] = useState({
            body: true,
            });
        const [savedData, setSavedData] = useState(initialFormData);
        const [PreviewFields, setPreviewFields] = useState(false);
        const [viewChanges, setViewChanges] = useState(false);
        const [originalData, setOriginalData] = useState(null);
        const [formDataSnapshot, setFormDataSnapshot] = useState(null);
        const [previewData, setPreviewData] = useState(null);
        const [detailedview, setDetailedView] = useState({});
        const [disabled, setDisabled] = useState(false);
        const [buttontext, setButtonText] = useState("Save");
        const [slug, setSlug] = useState("Save");
        const [userLoggedInRoles,setUserLoggedInRoles] = useState([]);
        const [searchValue, setSearchValue] = useState('');    
        const [options, setOptions] = useState([]);        
        const [selectedUser, setSelectedUser] = useState(null);    
    
        const [pages, setPages] = useState([]);

     
        const loggedin_drupal_uid = localStorage.getItem('drupal_uid');
        const domainName = window.location.hostname;

        const location  = useLocation();
        const drupal_uid = localStorage.getItem('drupal_uid');
        
        const {tab} = useParams();
        const {sid} = useParams();
        const loggedin_uid = localStorage.getItem('uid');
        const navigate = useNavigate();
        const app_url = configData.APP_URL;
        const domain_url = configData.DOMAIN_URL;
        
        const path = location.pathname.replace(/^\/+/, "");

        const [page, setPage] = useState(null);
        async function getplacementlist() {
            
                try {
                    const response = await fetch(
                        app_url+'node/getnodepages',
                        {
                            method: "GET",
        
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        }
                    )
                    const responsedata = await response.json();
                    if(responsedata.data) {
                        setPages(responsedata.data.result);
                    
                    } 
                } catch (err) {
                    
                }
                
        }

        function updateToggle(id){
            setToggle(id);
    
            if(id == 1) { 
                 window.location.href = "/" + page.url_slug;
               // navigate("/node/testimonial/"+sid+"/view");
            }
            if(id == 2) { 
                //navigate("/node/testimonial/"+sid+"/edit");
				 navigate("/"+page.url_source+"/edit");
            }
            
        }
        const getPageTitle = () => {
        const title = originalData?.title || "";

        if (toggle === 1) {
            return title ? title : "Testimonial";
        } else if (toggle === 2) {
            return title ? `Edit Testimonial ${title}` : "Edit Testimonial";
        }

        return "Edit Testimonial"; 
        };

        const getPageHeading = () => {
        const title = originalData?.title || "";

        if (toggle === 2) {
            return (
            <>
                Edit Testimonial {title}
            </>
            );
        }

        return null;
        };

        useEffect(() => {
        Promise.all([
            getuserloggedinroles(), 
            getPageData(),
            getplacementlist()
        ]).then(() => {
            setIsLoading(false);
            if(tab == "view") {
                setToggle(1);
            }
            if(tab == "edit") {
                setToggle(2);
            }
        })
            
        } ,[tab]);

        useEffect(() => {
            // Implement debouncing here if needed
            const fetchData = async () => {
                if (searchValue.trim() === '') {
                setOptions([]); // Clear options if search is empty
                return;
                }
                try {
                // Replace with your actual API call
                const response = await fetch(app_url+'testimonialpages/getaccountlist?query='+searchValue);
                const data = await response.json();
                setOptions(data.data.result); // Assuming data is an array of objects for Autocomplete
                } catch (error) {
                console.error('Error fetching data:', error);
                }
            };
            
            const handler = setTimeout(() => {
                fetchData();
            }, 500); // Debounce for 500ms
        
            return () => {
                clearTimeout(handler);
            };
        }, [searchValue]);
    
        // Fallback to name if label isn't present
        const getOptionLabel = (option) => {
        if (typeof option === 'string') return option;
        return option?.name || option?.label || '';
        };

        const renderOption = (props, option) => (
        <li {...props} key={option.id || option.name}>
            {option.name || option.label}
        </li>
        );
        
        const onChange = (event, newValue) => {
            setSelectedUser(newValue);
            setFormData((prev) => ({
                ...prev,
                user_id: newValue ? (newValue.id || newValue.user_id || '') : '', 
            }));
            if (newValue) {
                setSearchValue(newValue.name || newValue.label || '');
            } else {
                setSearchValue('');
            }
        };   
        async function getPageData() {
                try {
                    setIsLoading(true);
                    const response = await fetch(
                        app_url+'testimonialpages/geteditpagedata?path='+path,
                        {
                            method: "GET",
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        }
                    )
                    const responsedata = await response.json();
                    if(responsedata.data) {
                    setPage(responsedata.data);
                     setFormData({
                        ...responsedata.data,
                        placements: (responsedata.data.placements || []).map(item => ({
                            ...item,
                            isExisting: true,
                        })),
                    });
                    setOriginalData({
                        ...responsedata.data,
                        placements: responsedata.data.placements || [],
                    });
                    } 
                } catch (err) {
                    
                }finally {
                    setIsLoading(false); // Set loading to false after fetch completes (success or error)
                }
            }   
            async function getuserloggedinroles() {
                try {
                    setIsLoading(true);
                    const response = await fetch(
                        app_url+'viewprofile/getuserloggedinrolesid',
                        {
                            method: "GET",
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        }
                    )
                    const responsedata = await response.json();
                    if(responsedata.data) {
                        setUserLoggedInRoles(responsedata.data.roles);
                    } 
                } catch (err) {
                        
                }finally {
                    setIsLoading(false); 
                }
        }      
    

      
      const cleanHtmlOutput = (html) => {
        if (!html) return '';

        let cleaned = html;

        cleaned = cleaned.replace(/<\s*(p|div|h[1-6])[^>]*>\s*(<br\s*\/?>|\&nbsp;|\s)*\s*<\/\1\s*>/gi, '');

        cleaned = cleaned.replace(/<br\s*\/?>/gi, '');

        const textOnly = cleaned.replace(/&nbsp;|\s|<[^>]*>/g, '').trim();

        return textOnly.length === 0 ? '' : html.trim();
    };
      const toggleEditor = (field) => {
        setEditorMode(prev => ({
            ...prev,
            [field]: !prev[field]
        }));
    };

    const onEditorChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value,
        }));
    };

  const handleAddPlacement = () => {
        setFormData((prev) => ({
        ...prev,
        placements: [...prev.placements, { placement_page: '', placement_sort_order: '1',isExisting: false, }],
        }));
    };

    // const handleDeletePlacement = (index) => {
    //     const updated = formData.placements.filter((_, i) => i !== index);
    //     setFormData((prev) => ({ ...prev, placements: updated }));
    // };
   const handleDeletePlacement = (index) => {
        setFormData((prev) => {
            const itemToDelete = prev.placements[index];

														   
			   
            let updatedDeleted = [...(prev.deleted_placements || [])];
											 
			   
											  

            // Only store backend placements
            if (itemToDelete.isExisting && itemToDelete.placement_page) {
                updatedDeleted.push(itemToDelete.placement_page);
            }
		  
	   
  

            return {
                ...prev,
                placements: prev.placements.filter((_, i) => i !== index),
                deleted_placements: updatedDeleted,
            };
        });
    };	
    // const handlePlacementChange = (index, field, value) => {
    //     const updated = [...formData.placements];
    //     updated[index][field] = value;
    //     setFormData((prev) => ({ ...prev, placements: updated }));
    // };
    const handlePlacementChange = (index, field, value) => {
    setFormData((prev) => {
        const updated = [...prev.placements];
        updated[index] = { ...updated[index], [field]: value };
        return { ...prev, placements: updated };
    });
};
    const handlePreviewClick = () => {
    setViewChanges(false);
    const {
        title,
        summary,
        body,
        field_author_title,
        field_meta_title,
        field_meta_keywords,
        field_meta_description,
    } = formData;


    const newErrors = {};
    if (!title?.trim()) {
        newErrors.title = "Display Name field is required.";
    }
    

    if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        setPreviewFields(false);
        window.scrollTo({
        top: 0,
        behavior: "smooth",
    });
        return;
    }
    const bodyHtml = body || '';
    const hasSummary = summary && summary.trim() !== '';
    let trimmedHtml = '';

    if (hasSummary) {
    trimmedHtml = summary;
    } else if (bodyHtml.includes('<!--break-->')) {
    trimmedHtml = bodyHtml.split('<!--break-->')[0];
    } else {
    const tmp = document.createElement('div');
    tmp.innerHTML = bodyHtml;
    const plainText = (tmp.textContent || tmp.innerText || "").trim();

    trimmedHtml = '';
    }

    setPreviewData({
        title,
        summary: hasSummary ? summary : '',
        trimmed: trimmedHtml,
        body: bodyHtml,
        field_author_title,   
        field_meta_title,
        field_meta_keywords,
        field_meta_description,
    });
    window.scrollTo(0, 0);
    setErrors({});
    setPreviewFields(true);  
    };
    const handleViewChangesClick = () => {
    setPreviewFields(false);

    const newErrors = {};

    if (!formData.title?.trim()) {
        newErrors.title = "Display Name field is required.";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
        setViewChanges(false);

        window.scrollTo({
        top: 0,
        behavior: "smooth",
        });

        return;
    }

    setViewChanges(true);

    setFormDataSnapshot({
        ...formData,
    });

    setOriginalData(prev => ({
        ...prev,
    }));

    window.scrollTo({
        top: 0,
        behavior: "smooth",
    });
    };


    const handleChange = (e) => {
        const { name, type, value, checked } = e.target;

        if (type === 'checkbox') {
        setFormData((prev) => {
            const current = Array.isArray(prev[name]) ? prev[name] : [];

            return {
            ...prev,
            [name]: checked
                ? [...current, value]
                : current.filter((v) => v !== value),
            };
        });
        } else {
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
        }
    };
    
    const validateForm = () => {
        const newErrors = {};
        if (!formData.title.trim()) {
            newErrors.title = "Display Name is required.";
        }
        return newErrors;
    };
   const inputStyle = {
        title: {
        border: errors.title ? '2px solid red' : '1px solid #777'
        }
    };
 
    const handleSubmit = async (e) => {
        e.preventDefault();

        const validationErrors = validateForm();

        setErrors(validationErrors);
        setViewChanges(false);
        setPreviewFields(false);

        // If validation fails
        if (Object.keys(validationErrors).length > 0) {
            window.scrollTo({
            top: 0,
            behavior: "smooth",
            });
            return;
        }

        const finalBody = cleanHtmlOutput(formData.body);

        setDisabled(true);
        setButtonText("Saving...");

        const postData = new FormData();
        const updatedFormData = {
            ...formData,
            body: finalBody,    
        
        };

        postData.append("formData", JSON.stringify(updatedFormData));

        try {
           const response = await fetch(app_url + "testimonialpages/updatepage", {
            method: "POST",
            body: postData,
            });

            const data = await response.json();

            if (data.data.msg === "Success") {
                 //window.location.href= "/" + page.url_slug;
            // navigate("/" + page.url_slug, {
            //     state: { message: data.data.result },
            // });
            }
        } finally {
            setDisabled(false);
            setButtonText("Save");
        }
    };
    const handleDelete = async () => {
        if (window.confirm("Are you sure you want to delete?")) {
            const response = await fetch(
                app_url,
                    {
                        method: "GET",
                
                        headers: {
                        'Content-Type': 'application/json',
                        },
                    }
                )
            const data = await response.json();
            if(data.data.msg == "Success") {  
                navigate("/manage-testimonials", { state: { message: data.data.result } });
            }
        }
    };
    return(
         <>
            {isLoading ? (
                <Loading />
            ) : (
        <div id="main" className={` ${toggle === 2 ? "edit-blog-main" : "smww-agency-news-content-main"}`}>
        {(userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR)) ? <>
             <Helmet>
                <title>
                    {getPageTitle()}
                </title>
            </Helmet>
            <div className="left"></div>
            <div className="center left-center">
                  <>
                    <h1 className="edit-task-title">{getPageHeading()}</h1>
                  </>
                <>
                  {( userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR)) &&
                    <ul className="tabs primarya">
                      <li className= {toggle === 1? "active" : ""} onClick={()=> updateToggle(1)}>
                        <a style={{cursor: "pointer"}}>View</a>
                      </li>
                    
                      <li className= {toggle === 2? "active" : ""} onClick={()=> updateToggle(2)}>
                        <a style={{cursor: "pointer"}}>Edit</a>
                      </li>
                      {/* )} */}
                    </ul>
                  }
                </>
                <div  className= {toggle === 1 ? "show-content" : "content"}>
                    <ViewTestimonialPage />
                </div> 

                    {( userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR)) &&
                       <div  className= {toggle === 2? "show-content" : "content"}>
                         {viewChanges && (
                                <div className='diff-table-wrapper'>
                                <table className="diff-table">
                                <colgroup>
                                    <col className="diff-marker" />
                                    <col className="diff-content" />
                                    <col className="diff-marker" />
                                    <col className="diff-content" />
                                </colgroup>
                                <thead>
                                    <tr>
                                    <th colSpan="2">Original</th>
                                    <th colSpan="2">Changes</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {!formDataSnapshot || !originalData ? (
                                    <tr className="no-changes">
                                        <td className="diff-section-title" colSpan="4">No visible changes</td>
                                    </tr>
                                    ) : (
                                    (() => {
                                        const diffs = [];

    
                                const compareField = (label, oldValue = '', newValue = '') => {
                                    if (oldValue === newValue) return null;

                                    const oldLines = (oldValue ?? '').split('\n');
                                    const newLines = (newValue ?? '').split('\n');
                                    const maxLines = Math.max(oldLines.length, newLines.length);

                                    const rows = [
                                        <tr className="diff-section-title" key={`${label}-title`}>
                                        <td colSpan="4">Changes to <em>{label}</em></td>
                                        </tr>
                                    ];

                                    for (let i = 0; i < maxLines; i++) {
                                        const oldLine = (oldLines[i] || '').trim();
                                        const newLine = (newLines[i] || '').trim();

                                        if (oldLine !== newLine) {
                                        const oldWords = oldLine.split(/\s+/);
                                        const newWords = newLine.split(/\s+/);
                                        const maxWords = Math.max(oldWords.length, newWords.length);

                                        const renderWords = (wordsA, wordsB, isOld) =>
                                            wordsA.map((word, idx) => {
                                            const matchingWord = wordsB[idx] || '';
                                            const changed = word !== matchingWord;

                                            return (
                                                <span
                                                key={`${label}-${isOld ? 'old' : 'new'}-${i}-${idx}`}
                                                style={changed ? {
                                                    color: isOld ? 'red' : 'red',
                                                    borderRadius: '4px',
                                                    padding: '0 3px',
                                                    fontWeight:'bold'
                                                } : {}}
                                                >
                                                {word}
                                                {' '}
                                                </span>
                                            );
                                            });

                                        rows.push(
                                            <tr key={`${label}-${i}`}>
                                            <td style={{width:"2px"}}><span>-</span></td>
                                            <td className="diff-removed">{renderWords(oldWords, newWords, true)}</td>
                                            <td style={{width:"2px"}}><span>+</span></td>
                                            <td className="diff-added">{renderWords(newWords, oldWords, false)}</td>
                                            </tr>
                                        );
                                        }
                                    }

                                    return rows;
                                    };
                                    const compareFiles = (label, oldFiles = [], newFiles = []) => {
                                    const oldList = Array.isArray(oldFiles)
                                        ? oldFiles.map(f => f.name).join(', ')
                                        : '';

                                    const newList = Array.isArray(newFiles)
                                        ? newFiles.map(f => f.name).join(', ')
                                        : '';

                                    // If no difference, return an empty array (safe + iterable)
                                    if (oldList === newList) {
                                        return [];
                                    }
                                    // Otherwise return whatever diff UI compareField creates
                                    return [compareField(label, oldList, newList)];
                                    };


                                    diffs.push(...(compareField('Title', originalData.title, formDataSnapshot.title) || []));
                                    diffs.push(...(compareField('Summary', originalData.summary, formDataSnapshot.summary) || []));
                                    diffs.push(...(compareField('Body', originalData.body, formDataSnapshot.body) || []));

                                    diffs.push(
                                    ...(compareField(
                                        "Author Name",
                                        originalData.field_author_title,
                                        formDataSnapshot.field_author_title
                                    ) || [])
                                    );
                                
                                    diffs.push(
                                    ...(compareField(
                                        "Author Name",
                                        originalData.field_meta_title,
                                        formDataSnapshot.field_meta_title
                                    ) || [])
                                    );

                                    diffs.push(
                                    ...(compareField(
                                        "Author Title",
                                        originalData.field_meta_keywords,
                                        formDataSnapshot.field_meta_keywords
                                    ) || [])
                                    );         
                                    diffs.push(
                                    ...(compareField(
                                        "Mentor Link",
                                        originalData.field_meta_description,
                                        formDataSnapshot.field_meta_description
                                    ) || [])
                                    );               

                                    return diffs.length > 0 ? diffs : (
                                    <tr className="no-changes">
                                        <td className="diff-section-title" colSpan="4">No visible changes</td>
                                    </tr>
                                    );
                                })()
                                )}
                            </tbody>
                            </table>
                            </div>
                        )}
                {PreviewFields && (
                <>
                    <div
                    className="messages status"
                    style={{
                        background: `#f0f8eb url("/basic/web/images/message-ok.png") no-repeat`,
                        backgroundPosition: '10px 10px',
                    }}
                    >
                    The trimmed version of your post shows what your post looks like when promoted
                    to the main page or when exported for syndication.
                    <span>
                        You can insert the delimiter &lt;!--break--&gt; (without the quotes) to
                        fine-tune where your post gets split.
                    </span>
                    </div>

                    <div className="preview-container">
                    {/* Trimmed version */}
                    <div className="preview-trimmed">
                        <h4 className="preview-heading">
                        <span className="preview-square"></span> Preview trimmed version
                        </h4>

                        <div className="email-teaser">
                        <h2 className="email-title">
                            <a href={""}>{previewData?.title}</a>
                        </h2>

                        {/* <div className="email-teaser-block1">
                            <div className="email-teaser-block2"> */}
                            {(previewData.summary?.trim() || previewData.body?.includes('<!--break-->') || previewData.trimmed) && (
                <div
                    className="preview-body-content"
                    dangerouslySetInnerHTML={{ __html: previewData.trimmed }}
                />
                            )}
                            {/* </div>
                        </div> */}

                        <div className="read-more-link">
                            <a href={"/"}>Read more</a>
                        </div>
                        </div>
                    </div>

                    {/* Full version */}
                    <div className="preview-full">
                        <h4 className="preview-heading">
                        <span className="preview-square"></span> Preview full version
                        </h4>

                        <div className="email-teaser">
                        <h2 className="email-title">
                            {/* <strong>Body:</strong> */}
                        </h2>

                        {/* <div className="email-teaser-block1"> */}
                            {/* <div className="email-teaser-block2"> */}
                            <div
                                dangerouslySetInnerHTML={{
                                __html: previewData.body || '',
                                }}
                            />
                            <div className="email-meta">
                            {previewData.field_author_title && (
                            <p><strong>Title:</strong> {previewData.field_author_title}</p>
                            )}    
                            {previewData.field_meta_title && (
                            <p><strong>Meta Title:</strong> {previewData.field_meta_title}</p>
                            )}
                            {previewData.field_meta_keywords && (
                            <p><strong>Meta Keywords:</strong> {previewData.field_meta_keywords}</p>
                            )}
                            {previewData.field_meta_description && (
                            <p>
                                <strong>Meta Description:</strong> {previewData.field_meta_description}
                            </p>
                            )}
                    

                </div>

                        </div>
                    </div>
                    </div>
                </>
                )}
                    <div className="edit-blog-container">
                        {Object.values(errors).some(msg => !!msg) && (
                            <div
                            className="set-message-error error-message-padding"
                            style={{
                                background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 7px no-repeat`
                            }}
                            >
                            <ul>
                                {Object.values(errors)
                                .filter(msg => !!msg)
                                .map((msg, index) => (
                                    <li key={index}>{msg}</li>
                                ))}
                            </ul>
                            </div>
                        )}
                    <form onSubmit={handleSubmit}>
                        <div>
                            <div className="form-item">
                                <label htmlFor="create-agent-message-title">
                                    Display Name  
                                    <span className="form-required" title="This field is required.*">*</span>
                                </label>
                                <input 
                                    className="create-agent-message-title-field" 
                                    type="text" 
                                    id="create-agent-message-title" 
                                    name="title" 
                                    maxLength={100}
                                    onChange={handleChange} 
                                     value={formData.title}
                                    style={inputStyle.title}
                            
                                />
                                    {/* {errors.title && (
                                    <div className="form-error">{errors.title}</div>
                                )} */}
                            </div>
                            <div className="form-item edit-agent-block">
                                <label>Select a user (Autocomplete, search by First Name and/or Last Name) </label>
                                    <Autocomplete
                                        id="add_athlete_name"
                                        disablePortal
                                        options={options}
                                        size="small"
                                        sx={{ 
                                            width: "98%", 
                                            backgroundColor:"#fff",
                                            border: "1px solid rgb(119, 119, 119)",
                                            display: "inline-block"
                                        }}
                                        renderOption={renderOption}
                                        getOptionLabel={getOptionLabel}
                                        onChange={onChange}
                                        value={selectedUser}
                                        inputValue={searchValue}
                                        onInputChange={(event, newInputValue) => setSearchValue(newInputValue)}
                                        renderInput={(params) => (
                                            <TextField {...params} />
                                        )}
                                    />
                            </div>
                            <div className="form-item -field-meta-title">
                                <label htmlFor="meta_title">Meta Title</label>
                                <input className='' type="text" id="meta_title" name="field_meta_title" value={formData.field_meta_title} 
                                onChange={handleChange}  
                                /> 
                            </div>
                            <div className="form-item field-meta-keywords">
                                <label htmlFor="meta_keywords">Meta Keywords</label>
                                <input className='' type="text" id="meta_keywords" name="field_meta_keywords" value={formData.field_meta_keywords} 
                                    onChange={handleChange}
                                /> 
                            </div>
                            <div className="form-item  fieldmeta-description">
                                <label>Meta Description</label>
                                <textarea
                                    name="field_meta_description"
                                    value={formData.field_meta_description}
                                    onChange={handleChange}
                                    
                                />
                            <div className="grippie" style={{
                                  background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
                                    }}>   
                            </div>

                                </div>

                            <div className="form-item">
                                <label htmlFor="field_author_name">Title</label>
                                <input
                                    type="text"
                                    id="field_author_name"
                                    name="field_author_title"
                                    className="text-full form-text"
                                    value={formData.field_author_title}
                                    onChange={handleChange}
                                    maxLength={255}
                                />
                                </div>  
                                      
                            <div className="">
                                <div>
                                    {showSummary && (
                                        <div className="form-item">
                                            <label htmlFor="create_summary">
                                                Summary <span>(<a className="" href="#" onClick={(e) => { e.preventDefault(); setShowSummary(false); }}>Hide Summary</a>)</span>
                                            </label>
                                            <>
                                                <Editor 
                                                value={formData.summary} 
                                                onChange={(e) => {
                                                    const newValue = e?.target?.value || '';
                                                    setFormData((prev) => ({ ...prev, summary: newValue }));
                                                }}
                                                />
                                            </>
                                            <div className="description">Leave blank to use trimmed value of full text as the summary.</div>
                                        </div>
                                    )}
                            
                                    <div className="form-item">
                                        <label htmlFor="create_body">
                                            Body 
                                            {!showSummary && (
                                                <span>
                                                    (<a href="#" onClick={(e) => { e.preventDefault(); setShowSummary(true); }}>
                                                        Edit Summary
                                                    </a>)
                                                </span>
                                            )}
                                        </label>
                                        <>
                                            {editorMode.body ? (
                                                    <Editor
                                                        containerProps={{ style: { resize: 'vertical', height:'300px' } }}  
                                                        value={formData.body} 
                                                        onChange={e => onEditorChange('body', e.target.value)} 
                                                    />
                                                ) : (
                                                    <>
                                                        <textarea 
                                                            className="new-conference-form-textarea" 
                                                            name="body"
                                                            value={formData.body} 
                                                            onChange={e => onEditorChange('body', e.target.value)} 
                                                            rows={20} 
                                                        />
                                                        <div
                                                            className="grippie" 
                                                            style={{background: `#eee url(/images/grippie.png) no-repeat center 2px`,}}
                                                        >
                                                        </div>
                                                    </>
                                                    )}
                                            <a onClick={() => toggleEditor('body')}>Switch to {editorMode.body ? 'Plain' : 'Rich'} Editor</a>
                                        </>
                                    </div>
                                   
                                </div>
                          </div>                                                                      
                                  
                           
                        <fieldset 
                            className="form-wrapper" 
                            style={{
                                border: "1px solid #ccc", 
                                padding: "15px 20px", 
                                marginBottom: "15px",
                                fontFamily: "sans-serif"
                            }}
                        >
                        <div className="editprofile-fieldset-wrapper">
                            <label>PLACEMENTS</label>
                            <table 
                                style={{
                                    width: "100%",
                                    borderCollapse: "collapse",
                                    backgroundColor: "white",
                                    border: "1px solid #ccc",
                                    fontSize: "11px"
                                }} 
                                className="placements-table"
                            >
                                <thead>
                                    <tr style={{ backgroundColor: "#e1e2dc", borderBottom: "1px solid #ccc" }}>
                                        <th style={{ 
                                            width: '70%', 
                                            padding: '6px 10px', 
                                            textAlign: 'left', 
                                            fontWeight: 'bold', 
                                            color: '#333',
                                            textTransform: 'uppercase',
                                            borderRight: '1px solid #ccc'
                                        }}>
                                            Page
                                        </th>
                                        <th style={{ 
                                            width: '15%', 
                                            padding: '6px 10px', 
                                            textAlign: 'left', 
                                            fontWeight: 'bold', 
                                            color: '#333',
                                            textTransform: 'uppercase',
                                            borderRight: '1px solid #ccc'
                                        }}>
                                            Sort Order
                                        </th>
                                        <th style={{ 
                                            width: '15%', 
                                            padding: '6px 10px', 
                                            textAlign: 'center', 
                                            fontWeight: 'bold', 
                                            color: '#333',
                                            textTransform: 'uppercase'
                                        }}>
                                            Delete
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {formData.placements.map((placement, index) => (
                                        <tr key={index} style={{ borderBottom: index < formData.placements.length - 1 ? "1px solid #ccc" : "none" }}>
                                            {/* Page Select Column */}
                                            <td style={{ padding: '10px', borderRight: '1px solid #ccc' }}>
                                                <select
                                                    className="placement-select"
                                                    name={`placement_page_${index}`}
                                                    value={placement.placement_page}
                                                    onChange={(e) =>
                                                        handlePlacementChange(index, 'placement_page', e.target.value)
                                                    }
                                                    style={{
                                                        width: "100%",
                                                        padding: "4px",
                                                        border: "1px solid #ccc",
                                                        borderRadius: "2px",
                                                        fontSize: "12px",
                                                        boxSizing: "border-box"
                                                    }}
                                                >
                                                    <option value="">Select a page</option>
                                                    {pages.length > 0 && (
                                                        <>
                                                            {pages.map((item) => (
                                                                <option key={item['id']} value={item['id']}>
                                                                    {item['title']}
                                                                </option>
                                                            ))}
                                                        </>
                                                    )}
                                                </select>
                                            </td>

                                            {/* Sort Order Select Column */}
                                            <td style={{ padding: '10px', textAlign: 'center', borderRight: '1px solid #ccc' }}>
                                                <select
                                                    name={`placement_sort_order_${index}`}
                                                    className="adduser-form-select"
                                                    value={placement.placement_sort_order}
                                                    onChange={(e) =>
                                                        handlePlacementChange(index, 'placement_sort_order', e.target.value)
                                                    }
                                                    style={{
                                                        width: "100%",
                                                        maxWidth: "60px",
                                                        padding: "4px",
                                                        border: "1px solid #ccc",
                                                        borderRadius: "2px",
                                                        fontSize: "12px"
                                                    }}
                                                >
                                                    {[...Array(50)].map((_, i) => (
                                                        <option key={i + 1} value={i + 1}>
                                                            {i + 1}
                                                        </option>
                                                    ))}
                                                </select>
                                            </td>

                                            {/* Delete Button Column */}
                                            <td style={{ padding: '10px', textAlign: 'center' }}>
                                                <button
                                                    type="button"
                                                    className='quick-links-reg-button form-submit'
                                                    onClick={() => handleDeletePlacement(index)}
                                                    
                                                >
                                                    Delete
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            {/* Add Placement Link */}
                            <div style={{ marginTop: "12px" }}>
                                <a
                                    className="add-placement-link"
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleAddPlacement();
                                    }}
                                    style={{
                                        color: "#0071B8",
                                        textDecoration: "none",
                                        fontWeight: "bold",
                                        fontSize: "12px"
                                    }}
                                    onMouseOver={(e) => e.currentTarget.style.textDecoration = "underline"}
                                    onMouseOut={(e) => e.currentTarget.style.textDecoration = "none"}
                                >
                                    + Add
                                </a>
                            </div>
                        </div>
                    </fieldset>     
                         
                            <div className="form-item">
                                <label htmlFor="edit-path-alias">
                                    URL alias
                                </label>
                                <input
                                    type="text" 
                                    id="edit-path-alias" 
                                    name="url_alias" 
                                    // maxLength={100}
                                    onChange={handleChange} 
                                    value={formData.url_alias}
                            
                                />
                            <p className="description" style={{marginTop: "5px"}}>Optionally specify an alternative URL by which this content can be accessed. For example, type "about" when writing an about page. 
                              Use a relative path and don't add a trailing slash or the URL alias won't work.</p>
                            </div>       
                      
                            <div className="form-actions form-wrapper" id="create-actions">
                                {/* <input type="submit" id="create-submit" name="" value="Save" className="form-submit" />&nbsp;&nbsp; */}
                                <button type="submit" className="form-submit" disabled={disabled}>{buttontext}</button>&nbsp;&nbsp;
                               <input 
                                    type="button" 
                                    id="edit-preview"  
                                    value="Preview" 
                                    className="form-submit" 
                                    onClick={()=> {
                                    handlePreviewClick();
                                    // window.scrollTo({ top: 0, behavior: 'smooth' });
                                    }}
                                />&nbsp;&nbsp;
                                <input
                                    type="button"
                                    id="edit-task-preview-changes"
                                    value="View changes"
                                    className="form-submit"
                                    onClick={handleViewChangesClick}
                                />&nbsp;&nbsp;
                                <input type="button" id="edit-task-delete" name="" value="Delete" className="form-submit" onClick={handleDelete} />
                            </div>
                        </div>
                    </form>
                </div>
                </div>
}
            </div>
        </> : (<><p>You are not authorized</p></>)}
        </div>
            )}
            </>
    );
};
export default EditTestimonialPage;
/*vs code js*/